import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { CampaignProvider } from './context/CampaignContext'
import { UIProvider } from './context/UIContext'
import Layout from './components/layout/Layout'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 25_000,
    },
  },
})

const App = () => (
  <QueryClientProvider client={queryClient}>
    <CampaignProvider>
      <UIProvider>
        <Layout />
      </UIProvider>
    </CampaignProvider>
  </QueryClientProvider>
)

export default App
